// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Utilities
import { populatePath, translateDate } from 'common/utils/helpers';

// Enums
import { ResultsSummaryType } from 'engagementReport/enums/propTypes';
import ProjectStatus from 'project/enums/ProjectStatus';

// Routes
import Routes from 'routes';
import { useIsFiltered } from '../hooks';

const ResultsSummaryHero = ({ resultsSummary, projectStatus, projectHubEnabled }) => {
  const params = useParams();
  const { t } = useTranslation();
  const { engagement, filterOptions } = resultsSummary;
  const { project } = engagement;
  const showProjectHubLink =
    projectHubEnabled &&
    (projectStatus === ProjectStatus.ACTIVE || projectStatus === ProjectStatus.FINISHED);
  const filtered = useIsFiltered(filterOptions);
  const asterisk = filtered ? '*' : '';
  const participantsText = `${resultsSummary.engagementSummary.started} ${t(
    'engagement_report.participants'
  )} ${asterisk}`;
  const { startTime } = resultsSummary.engagementSummary;
  const { endTime } = resultsSummary.engagementSummary;

  return (
    <div className="results-summary-hero">
      <div className="container inner">
        <div className="columns">
          <div className="column">
            <div>
              <b>{resultsSummary.title}</b>．Created: {translateDate(resultsSummary.createdAt, t)}
            </div>
            <h1 className="title is-2 is-primary-color results-summary-hero__title">
              {engagement.title}
            </h1>
            <div className="results-summary-hero__meta results-summary-hero__meta--engagement">
              <div>
                {translateDate(startTime, t)}{' '}
                {Boolean(endTime) && `to ${translateDate(endTime, t)}`}
              </div>
              <div>{participantsText}</div>
            </div>
            {showProjectHubLink && (
              <div className="results-summary-hero__project-link">
                Part of{' '}
                <a
                  href={populatePath(Routes.PROJECT, params)}
                  className="is-secondary-color results-summary-hero__meta-link"
                >
                  {project.title}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

ResultsSummaryHero.propTypes = {
  resultsSummary: ResultsSummaryType.isRequired,
  projectStatus: PropTypes.string,
  projectHubEnabled: PropTypes.bool.isRequired,
};

ResultsSummaryHero.defaultProps = {
  projectStatus: '',
};

export default ResultsSummaryHero;
